import { WORKSPACE_PICKER_PATH } from "./workspace-picker-path";

const [, PICKER_QUERY] = WORKSPACE_PICKER_PATH.split("?");

export function isWorkspacePickerRequested(searchParams: URLSearchParams): boolean {
  return [...new URLSearchParams(PICKER_QUERY)].every(([name, value]) => searchParams.get(name) === value);
}
